module.exports = __webpack_public_path__ + "static/media/order-confirmation-paperbag.5e2b1e4f.png";